import { Component } from '@angular/core';
import {environment} from "@environment";

@Component({
    selector: 'app-complaints-and-disputes',
    templateUrl: './complaints-and-disputes.component.html',
    styleUrl: './complaints-and-disputes.component.scss',
    standalone: false
})
export class ComplaintsAndDisputesComponent {
  environment: any = environment;
}
